import * as types from "../constants";

const initialState = {
	day: null,
	teams: [],
	games: [],
	sports: [],
	nextDate: null,
	previousDate: null,
	currentDate: null,
	filter: {
		team: '',
		sport: '',
		gameState: 1, //0, 1, 3
	},
	channels: [],
	isRequest: false,
	channelLiveStats: []
};

const getTodayTeamsOrSports = (games, filter) =>
{
	if (!Array.isArray(games)) return;

	let teams = [], sports = [];

	games.forEach(game =>
	{

		if (game.gameState !== filter.gameState)
		{
			return
		}

		if (game.awayTeam && game.awayTeam.name && !teams.includes(game.awayTeam.name))
		{
			teams.push(game.awayTeam.name);
		}
		if (game.homeTeam && game.homeTeam.name && !teams.includes(game.homeTeam.name))
		{
			teams.push(game.homeTeam.name);
		}
		if (game.grouping && !sports.includes(game.grouping))
		{
			sports.push(game.grouping);
		}
	});

	teams.sort().unshift('');
	sports.sort().unshift('');

	return {teams: teams, sports: sports};
};
const fillZero = date =>
{
	if (date === undefined)
	{
		return
	}

	let _arr = date.split('-');
	_arr = _arr.map(item =>
	{
		let _item = Number(item);
		_item = _item < 10 ? "0" + _item : _item;
		return _item;
	}).join('-');
	return _arr;
}
const getSchedule = (state = initialState, action) =>
{
	switch (action.type)
	{
		case types.GET_SCHEDULE_BEGIN:
			return {...state, isRequest: true}
		case types.GET_SCHEDULE:
			const {currentDate, previousDate, nextDate, games, day} = action.scheduleData;
			return {
				...state,
				isRequest: false, ...action.scheduleData,
				previousDate: action.isLive ? NEU.formatDate(new Date(new Date(currentDate).getTime() - 24 * 60 * 60 * 1000), 'yyyy-MM-dd') : previousDate,
				nextDate: action.isLive ? NEU.formatDate(new Date(new Date(currentDate).getTime() + 24 * 60 * 60 * 1000), 'yyyy-MM-dd') : nextDate,
				day: action.isLive ? NEU.formatDate(currentDate, 'yyyy-MM-dd') : fillZero(day), ...getTodayTeamsOrSports(games, state.filter)
			};
		case types.CHANGE_FILTERS:
			return {
				...state,
				filter: {...state.filter, ...action.filter}, ...getTodayTeamsOrSports(state.games, {...state.filter, ...action.filter})
			};
		case types.GET_CHANNELS:
			return {...state, channels: action.channels};
		case types.GET_CHANNELS_LIVE_STATS:
			return {...state, channelLiveStats: JSON.parse(JSON.stringify(action.liveStats))}
		default:
			return state;
	}
};

export default getSchedule;